import { IncidentStatistics, PortfolioStatistics, UserStatistics } from "entities/common";
import { DeviceStatistics } from "entities/devices";
import { GET } from "utils/http";

const baseUrl = "/api/statistics";

export const getUserStatistics = () => GET<UserStatistics>(`${baseUrl}/users`);

export const getPortfolioStatistics = () => GET<PortfolioStatistics>(`${baseUrl}/portfolios-overview`);

export const getIncidentStatistics = (query = "") =>
  GET<IncidentStatistics>(`${baseUrl}/incidents-overview${query}`, { skipAuthRedirect: true });

export const getDeviceStatistics = (query = "") =>
  GET<DeviceStatistics>(`${baseUrl}/devices${query}`, { skipAuthRedirect: true });
